// React & Memoization
import { memo } from "react";

// API & Constants
import { initialDataWithPagination } from "services/api/consts";
import { CALCULATION_VEHICLE_SERVICES_SEARCH_COLUMNS } from "./consts";

// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// Types
import { VehicleServicesSearchResultsProps } from "./types";


const VehicleServicesSearchResults: React.FC<
  VehicleServicesSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={CALCULATION_VEHICLE_SERVICES_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(VehicleServicesSearchResults);
